import { render, staticRenderFns } from "./trackingsView.vue?vue&type=template&id=05de07c2"
import script from "./trackingsView.vue?vue&type=script&lang=js"
export * from "./trackingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports